import request from '@/utils/request'


export function insertFile(param) {
  return request({
    url: '/userFile/insertContent',
    method: 'post',
    params: param
  })
}

export function getUserFile(status) {
  return request({
    url: '/userFile/userContent',
    method: 'get',
    params:{status:status}
  })
}



// WEBPACK FOOTER //
// ./src/api/userFile.js